import React from "react";


const Nested = ({ label, imageUrl, alt, nestedSection, isSelected, onNestedClick }) => {
    const handleClick = () => {
        if (nestedSection && onNestedClick) {
            onNestedClick(nestedSection);
        }
    }

    return(
        <>
            <div className=" d-flex justify-content-center col-md-6 col-12 px-3 mb-3">
                <div 
                    className={`border-nested product-card-2 ${isSelected ? 'selected' : ''}`} 
                    onClick={handleClick} 
                    style={{ 
                        cursor: nestedSection ? 'pointer' : 'default',
                        border: isSelected ? '2px solid #B39C81' : '1px solid #ddd',
                        backgroundColor: isSelected ? '#f9f7f4' : 'transparent'
                    }}
                >
                    <div className="p-3">
                        <div className="image2">
                            <img src={imageUrl} alt={alt} />
                            <div className="etiquette container p-2 left-0 bottom-0">
                                <span style={{ color: "white", fontWeight: "bold" }}>{label}</span>
                            </div>
                        </div>
                        <div className="description mt-3">
                            <div className="d-flex justify-content-between">
                                <span />
                                <div className="checkbox-container ">
                                    <input type="checkbox" className="custom-checkbox " checked={isSelected} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Nested